"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _PDFViewerToolbar = _interopRequireDefault(require("./PDFViewerToolbar/PDFViewerToolbar"));

var _P = _interopRequireDefault(require("../../typography/text/P"));

var _styles = require("./styles");

var _reactPdf = require("react-pdf");

var _hooks = require("./hooks");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MOBILE_SCALE_FACTOR = 1;
const DESKTOP_SCALE_FACTOR = 3; // enable web-worker to give the best performance

_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${_reactPdf.pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({
  file,
  filename,
  options,
  className,
  pdf,
  setTimeout,
  ...otherProps
}) => {
  const scrollRef = (0, _react.useRef)();
  const {
    rootRef,
    handleScroll,
    viewerOptions,
    blob,
    objectURL,
    currentPage,
    numPages,
    pdfDocument,
    zoom,
    fullScreen,
    progress,
    ready,
    error,
    isMobile,
    download,
    showDocumentPreview,
    showProgressIndicator,
    progressLabel,
    onDocumentLoaded,
    onPageRendered,
    onToggleFullScreen,
    onPageNumberChange,
    onZoomChange
  } = (0, _hooks.usePDFViewer)({
    file,
    filename,
    scrollRef,
    options,
    setTimeout
  });

  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledPDFViewer, {
      ref: rootRef,
      className: className ? `rui-pdf-viewer ${className}` : `rui-pdf-viewer`,
      fullScreen: fullScreen,
      "data-pdf-fullscreen": fullScreen,
      options: viewerOptions,
      ...otherProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DocumentErrorMessage, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_P.default, {
          children: "This document is currently unavailable. Please try again later."
        })
      })
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledPDFViewer, {
    ref: rootRef,
    className: className ? `rui-pdf-viewer ${className}` : `rui-pdf-viewer`,
    fullScreen: fullScreen,
    "data-pdf-fullscreen": fullScreen,
    options: viewerOptions,
    ...otherProps,
    children: [showProgressIndicator && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProgressIndicator, {
      progress: progress,
      radius: 60,
      stroke: 6,
      label: progressLabel
    }), ready && viewerOptions.showToolbar && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PDFViewerToolbar.default, {
      rootRef: rootRef,
      blob: blob,
      currentPage: currentPage,
      numPages: numPages,
      zoom: zoom,
      isMobile: isMobile,
      options: viewerOptions,
      download: download,
      onPageNumberChange: onPageNumberChange,
      onZoomChange: onZoomChange,
      fullScreen: fullScreen,
      onToggleFullScreen: onToggleFullScreen
    }), pdfDocument && !showDocumentPreview && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DocumentErrorMessage, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_P.default, {
        children: "This document is too large to preview"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DocumentErrorActions, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DownloadButton, {
          primary: true,
          onClick: download,
          children: "Download PDF"
        }), viewerOptions.previewUnavailableButtons && viewerOptions.previewUnavailableButtons.length > 0 && viewerOptions.previewUnavailableButtons.map((Button, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {}, index))]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ScrollArea, {
      containerRef: ref => {
        scrollRef.current = ref;
      },
      onScrollY: handleScroll,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PDFViewerDocument, {
        ready: ready,
        "data-pdf-ready": ready,
        zoom: zoom,
        options: viewerOptions,
        children: [blob && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPdf.Document, {
          file: blob,
          onLoadSuccess: onDocumentLoaded,
          className: "document",
          children: showDocumentPreview && [...Array(numPages)].map((page, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `document__page document__page__${index + 1}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPdf.Page, {
              className: "pdf-page",
              pdf: pdfDocument,
              pageIndex: index,
              scale: isMobile ? MOBILE_SCALE_FACTOR : DESKTOP_SCALE_FACTOR,
              onRenderSuccess: onPageRendered,
              renderAnnotationLayer: false,
              renderTextLayer: false
            })
          }, index))
        }), objectURL && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PrintIframe, {
          src: objectURL,
          title: "pdf-print-frame",
          name: "print_frame",
          id: "print_frame",
          frameBorder: "0"
        })]
      })
    })]
  });
};

PDFViewer.contextTypes = {
  scrollArea: _propTypes.default.object
};
PDFViewer.propTypes = {
  filename: _propTypes.default.string,
  file: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  options: _propTypes.default.object
};
PDFViewer.defaultProps = {
  filename: 'Document',
  options: {}
};
PDFViewer.displayName = 'PDFViewer';
_styles.StyledPDFViewer.displayName = 'PDFViewer';

var _default = (0, _reactTimeout.default)(PDFViewer);

exports.default = _default;